import React from 'react';
import Footer from '../Footer';

import { 
    Button 
} from '@mui/material';

import {useNavigate} from 'react-router-dom';

function NotFoundPage() {
    const navigate = useNavigate();
    return (
        <React.Fragment>
            <div className="container-fluid">
                <div className="row mt-5">
                    <div className="col-sm-12 col-md-12 col-lg-4 mx-auto">
                        <div className="d-flex flex-column align-items-center justify-content-center w-100">
                            <h1>Page is Not Found</h1>
                            <p>This page you are trying to access is not found.</p>
                            <Button
                                name="Reset Password"
                                classes="btn btn-primary btn-block login-button"
                                type='button'
                                onClick={() =>  navigate('/')}
                            >
                                Go Back
                            </Button>   
                        </div>   
                    </div>
                </div>
            </div>
            <Footer />
        </React.Fragment>
    );
}

export default NotFoundPage;
